// Canonical client-side formatter for note timestamps.
//
// Mirrors the named Ruby formats used to server-render notes so a note injected
// into the DOM after an AJAX save reads identically to one rendered by Rails:
//
//   withSeconds: false (default) -> :am_pm_full_year_short  "6/24/2026 1:09 AM"
//   withSeconds: true            -> :am_pm_full_year         "6/24/2026 1:09:45 PM"
//
// (:am_pm_full_year and :standard_datetime are byte-identical.)
//
// Always go through this helper instead of toLocaleString / dateStyle:"short" —
// those emit a 2-digit year and a comma ("6/24/26, 1:09 PM"), which is NOT our
// format. Pass `timeZone` (an IANA id) to render in the recipient's zone, matching
// the server's `display_created_at`; omit it to fall back to the browser zone.
export function formatNoteTimestamp(value, { withSeconds = false, timeZone } = {}) {
  if (!value) return "";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  const options = {
    month: "numeric",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  };
  if (withSeconds) options.second = "2-digit";
  if (timeZone) options.timeZone = timeZone;

  const parts = new Intl.DateTimeFormat("en-US", options)
    .formatToParts(date)
    .reduce((acc, part) => {
      acc[part.type] = part.value;
      return acc;
    }, {});

  const time = withSeconds
    ? `${parts.hour}:${parts.minute}:${parts.second}`
    : `${parts.hour}:${parts.minute}`;

  return `${parts.month}/${parts.day}/${parts.year} ${time} ${parts.dayPeriod}`;
}
